import axios from 'axios';

const config = {
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
};

const requests = axios.create(config);

export default requests;
